import React, { useContext, useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import Tree from 'rc-tree';
import CustomModal from '../../../Modal';
import ReportComponent from '../../../../utils/ReportComponent/ReportComponent';
import CustomTooltip from '../../../Tooltip';
import Icon from '../../../Icon';
import { I18nContext } from 'utils/I18n/context';

const images = {
    settings: require('img/icons/settings.svg'),
};

const reportUtils = ReportComponent.utils;

export const StatisticsMetrics = (props) => {
    const { t } = useContext(I18nContext) || {};
    const [state, setState] = useState({
        data: props.data || [],
        expandedKeys: props.checkedKeys || [],
        checkedKeys: props.checkedKeys || [],
        metrics: props.metrics,
        isVisibleModal: false,
        isVisibleModalTagSettings: false
    });

    useEffect(() => {
        setState(prev => ({
            ...prev,
            checkedKeys: props.checkedKeys || [],
            metrics: props.metrics,
            data: props.data
        }));
    }, [props.checkedKeys, props.metrics, props.data]);

    const onToggleModal = useCallback(() => {
        setState(prev => ({
            ...prev,
            isVisibleModal: !prev.isVisibleModal
        }));
    }, []);

    const onToggleModalTagSettings = useCallback(() => {
        setState(prev => ({
            ...prev,
            isVisibleModalTagSettings: !prev.isVisibleModalTagSettings
        }));
    }, []);

    const onAction = useCallback(() => {
        // Use checkedKeys directly - these are the actual selected metrics
        props.onAction(state.checkedKeys);
    }, [props, state.checkedKeys]);

    const onCheck = useCallback((checkedKeys) => {
        setState(prev => ({
            ...prev,
            checkedKeys,
            metrics: reportUtils.getStrMetric(checkedKeys)
        }));
    }, []);

    const onExpand = useCallback((expandedKeys) => {
        setState(prev => ({
            ...prev,
            expandedKeys
        }));
    }, []);

    const onClearExpand = useCallback(() => {
        setState(prev => ({
            ...prev,
            expandedKeys: []
        }));
    }, []);

    const setServerStorage = useCallback(() => {
        props.saveServerStorage(state.checkedKeys);
    }, [props, state.checkedKeys]);

    const onConfirm = useCallback(async () => {
        onAction();
        onToggleModal();
        try {
            await setServerStorage();
            console.log('Metrics saved and data refreshed successfully');
        } catch (error) {
            console.error('Failed to save metrics:', error);
        }
    }, [onAction, onToggleModal, setServerStorage]);

    const onConfirmTagSettings = useCallback(async () => {
        onAction();
        onToggleModalTagSettings();
        try {
            await setServerStorage();
            console.log('Metrics saved and data refreshed successfully');
        } catch (error) {
            console.error('Failed to save metrics:', error);
        }
    }, [onAction, onToggleModalTagSettings, setServerStorage]);

    const getTreeData = useCallback(() => {
        const buildTreeData = (level = 0, parentKey = null) => {
            return state.data[level]
                .filter((item) => !parentKey || item.config.parentKey === parentKey)
                .map((item) => {
                    let config = item.config;
                    let children = config.metrics || config.children;
                    let nextLevel = config.metrics ? state.data.length - 1 : level + 1;

                    return {
                        key: config.key,
                        title: (
                            <span>
                                {item.config.key === 'GroupBy' ? 'GroupBy' : item.title}
                                {item.description
                                    ? <CustomTooltip id={config.key} placement={'right'} tooltip={item.description}><Icon name={'fa-question-circle rc-tree-help'} /></CustomTooltip>
                                    : null
                                }
                            </span>
                        ),
                        disableCheckbox: item.config.key === 'GroupBy',
                        children: children ? buildTreeData(nextLevel, config.key) : undefined
                    };
                });
        };

        return buildTreeData();
    }, [state.data]);


    const staticNames = t?.reportPage || {};

    return (
        <React.Fragment>
            <React.Fragment>
                <button id="metricsPopup" className="btn"  onClick={onToggleModal}>
                        <img src={images.settings} alt=""/>
                    </button>
                    <CustomModal
                        className={'settingsMenu'}
                        title={staticNames.metricsTitle}
                        confirmName={staticNames.applyMetrics}
                        visible={state.isVisibleModal}
                        onClose={onToggleModal}
                        onConfirm={onConfirm}
                    >
                        <div className="row">
                            <div className="col-7">
                                <Tree
                                    className="myCls"
                                    showLine
                                    checkable
                                    selectable={false}
                                    showIcon={false}
                                    defaultExpandedKeys={state.checkedKeys}
                                    expandedKeys={state.expandedKeys}
                                    checkedKeys={state.checkedKeys}
                                    onExpand={onExpand}
                                    onCheck={onCheck}
                                    treeData={getTreeData()}
                                />
                            </div>
                            <div className="col-5 d-flex text-right justify-content-center align-items-start">
                                <button
                                    className="btn btn-outline btn-success"
                                    type="button"
                                    disabled={!state.expandedKeys.length}
                                    onClick={onClearExpand}
                                >
                                    {staticNames.collapseAll}
                                </button>
                            </div>
                        </div>
                    </CustomModal>
                </React.Fragment>
            </React.Fragment>
    );
};

StatisticsMetrics.propTypes = {
    data: PropTypes.array,
    checkedKeys: PropTypes.array,
    metrics: PropTypes.array,
    onAction: PropTypes.func,
    saveServerStorage: PropTypes.func
};

export default StatisticsMetrics;
